exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/wamp64/www/duetz.repos/angular4/src/app/_components/serviceprovidertypes/editserviceprovidertype/editserviceprovidertype.component.css
// module id = ../../../../../src/app/_components/serviceprovidertypes/editserviceprovidertype/editserviceprovidertype.component.css
// module chunks = 1